import React from "react";

import { PhonePreview } from "./PhonePreview";

const SaveRedeemSection: React.FC = () => {
  return (
    <div>
      <div className="hidden lg:block px-6">
  <section className="w-full flex justify-center">
  <div className="w-full max-w-[1700px]">
    <div className="
      relative w-full bg-[#f7f7f7] rounded-[40px]
      px-6 md:px-[40px]
      py-10 md:py-0
      flex flex-col md:flex-row
      items-center justify-between
      overflow-visible
    ">

      {/* LEFT — Phone */}
      <div className="relative flex items-center justify-center"
        style={{ width: "clamp(280px, 35vw, 600px)", height: "clamp(340px, 45vw, 650px)" }}
      >
        <PhonePreview />
      </div>

      {/* RIGHT — Content */}
      <div style={{ maxWidth: "clamp(280px, 38vw, 520px)" }} className="w-full pb-10 md:pb-0">

        {/* label */}
        <div className="flex items-center gap-3 mb-4">
          <div className="w-[10px] h-[10px] rounded-full bg-red-600 flex-shrink-0" />
          <span className="text-gray-600 font-medium" style={{ fontSize: "clamp(14px, 1.2vw, 18px)" }}>
            Save for later
          </span>
        </div>

        {/* title */}
        <h2
          className="font-semibold text-black mb-6"
          style={{ fontSize: "clamp(28px, 3.5vw, 52px)", lineHeight: "1.2" }}
        >
          Your Favourite Deals,<br />Always Ready.
        </h2>

        {/* description */}
        <p
          className="text-gray-600 leading-[1.7] mb-8"
          style={{ fontSize: "clamp(14px, 1.2vw, 18px)" }}
        >
          Spot a great offer? Save deals with one tap to ensure your top offers are organized, handy, and ready to redeem.
        </p>

        {/* features */}
        <div className="flex flex-wrap gap-6 mb-10">
          {["Quick Access", "Easy Redemption"].map((feature) => (
            <div key={feature} className="flex items-center gap-3">
              <div className="w-5 h-5 bg-red-600 rounded-full flex items-center justify-center text-white text-xs flex-shrink-0">
                ✓
              </div>
              <span style={{ fontSize: "clamp(14px, 1.2vw, 18px)" }}>{feature}</span>
            </div>
          ))}
        </div>

        {/* store buttons */}
        <div className="flex flex-wrap gap-4">
          {[
            { src: "/images/AppleLogo.png", alt: "Download on the App Store" },
            { src: "/images/rectangle-34625679.png", alt: "Get it on Google Play" },
          ].map(({ src, alt }) => (
            <a
              key={alt}
              href="https://couponbook.app.link/BsnZ5PEfH2b"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={alt}
              className="flex items-center justify-center bg-black rounded-[30px] hover:opacity-90 transition"
              style={{
                width: "clamp(140px, 14vw, 226px)",
                height: "clamp(48px, 4.5vw, 64px)",
              }}
            >
              <img src={src} alt={alt} className="object-contain" style={{ width: "clamp(100px, 10vw, 162px)" }} />
            </a>
          ))}
        </div>

      </div>
    </div>
  </div>
</section>
      </div>

      <div className="block lg:hidden mt-24 ">
      <section className="w-full flex justify-center relative">

  <div className="w-full max-w-[420px]">

    <div className="bg-[#F9F0F0] rounded-[28px] px-5 py-8 flex flex-col items-center text-center">

      {/* LABEL */}
      <div className="flex items-center gap-2 mb-3">
        <div className="w-[10px] h-[10px] bg-red-600 rounded-full" />
        <span className="text-[18px] text-gray-600 font-medium">
          Save For Later
        </span>
      </div>

      {/* TITLE */}
      <h2 className="text-[20px] leading-[34px] font-semibold text-black mb-3 px-6">
        Your Favourite Deals, Always Ready.
      </h2>

      {/* DESCRIPTION */}
      <p className="text-[12px] leading-[20px] text-gray-600  px-2">
        Spot a great offer? Save deals with one tap to ensure your top offers are organized, handy, and ready to redeem.
      </p>

      {/* PHONE */}
      <div className="relative flex justify-center items-center ">
        <div className="scale-[0.78]">
          <PhonePreview />
        </div>
      </div>

      {/* FEATURES CARD */}
      <div className="relative w-full top-[-30px]">
          <div className="relative bg-[#ffffff] rounded-[20px] px-5 py-4 flex justify-between w-full mb-6">

        <div className="flex items-center gap-2">
          <div className="
          w-4 h-4
          rounded-full
          bg-red-600
          flex items-center justify-center
        ">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-3 h-3 text-white"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.704 5.29a1 1 0 010 1.42l-7.25 7.25a1 1 0 01-1.42 0l-3.25-3.25a1 1 0 111.42-1.42l2.54 2.54 6.54-6.54a1 1 0 011.42 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
          <span className="text-[13px] text-gray-800">
            Quick Access
          </span>
        </div>

        <div className="flex items-center gap-2">
          <div className="
          w-4 h-4
          rounded-full
          bg-red-600
          flex items-center justify-center
        ">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-3 h-3 text-white"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.704 5.29a1 1 0 010 1.42l-7.25 7.25a1 1 0 01-1.42 0l-3.25-3.25a1 1 0 111.42-1.42l2.54 2.54 6.54-6.54a1 1 0 011.42 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
          <span className="text-[13px] text-gray-800">
            Easy Redemption
          </span>
        </div>

      </div>

      {/* BUTTONS */}
      <div className="flex flex-col gap-3 w-full">

        {/* APP STORE */}
        <a
          href="https://couponbook.app.link/BsnZ5PEfH2b"
          target="_blank"
          className="flex items-center justify-center h-[52px] w-full bg-black rounded-full" rel="noreferrer"
        >
          <img
            src="/images/AppleLogo.png"
            className="w-[130px]"
          />
        </a>

        {/* GOOGLE PLAY */}
        <a
          href="https://couponbook.app.link/BsnZ5PEfH2b"
          target="_blank"
          className="flex items-center justify-center h-[52px] w-full bg-black rounded-full" rel="noreferrer"
        >
          <img
            src="/images/rectangle-34625679.png"
            className="w-[130px]"
          />
        </a>

      </div>
      </div>
    

    </div>

  </div>

</section>
      </div>
    </div>
   
  );
};

export default SaveRedeemSection;